module.exports = __webpack_public_path__ + "img/xiazai3.49830dec.png";